import React, { useState } from 'react';
import { Col, Row, Card, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, SaveButton } from '../../util/buttons';
import ImmutableUnderReviewFormControl from '../../util/reviewEditControls/ImmutableUnderReviewFormControl';
import { setHasImportantUnsavedChanges } from '../../store/features/unsavedChangesSlice';
import FileUpload from '../../util/FileUpload';
const renderSaveButton = (type, buttonProps, submitLabel) => {
  if (type === 'save') {
    return /*#__PURE__*/React.createElement(SaveButton, buttonProps);
  } else {
    return /*#__PURE__*/React.createElement(Button, buttonProps, submitLabel);
  }
};

/**
 * @param String uploadIcon icon on the add document button (e.g. 'cloud_upload'), default 'add'
 */
const TechnicalUploadsForm = _ref => {
  let {
    type,
    isImmutableUnderReview = false,
    handleSubmit,
    loading,
    isSignedOff,
    showDocumentType = true,
    showAddCommentTextInput = true,
    addDocumentClass = {},
    uploadIcon = 'add'
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [technicalUpload, setTechnicalUpload] = useState({
    document_type: 'tax_computations'
  });
  const handleChange = e => {
    dispatch(setHasImportantUnsavedChanges(true));
    setTechnicalUpload({
      ...technicalUpload,
      comments: e.target.value
    });
  };
  const onDocumentTypeChange = e => {
    dispatch(setHasImportantUnsavedChanges(true));
    setTechnicalUpload({
      ...technicalUpload,
      document_type: e.target.value
    });
  };
  const selectFile = file => {
    dispatch(setHasImportantUnsavedChanges(true));
    setSelectedFile(file);
  };
  const submit = () => {
    handleSubmit(technicalUpload, selectedFile);
    setSelectedFile(null);
    dispatch(setHasImportantUnsavedChanges(false));
    setTechnicalUpload({
      document_type: 'tax_computations'
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 2,
    style: addDocumentClass
  }, /*#__PURE__*/React.createElement(FileUpload, {
    title: t('upload_document'),
    defaultBodyIcon: uploadIcon,
    defaultDesignCustomStyle: {
      width: 'auto'
    },
    file: selectedFile,
    onSelectFile: selectFile,
    disabled: loading || isSignedOff
  })), showAddCommentTextInput && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 2
  }, t('please_add_additional_comments')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    onChange: handleChange,
    name: "comments",
    value: technicalUpload.comments || '',
    size: "md",
    type: "text"
  }))), showDocumentType && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 2
  }, t('please_select_document_type')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: "select",
    value: technicalUpload.document_type,
    onChange: e => onDocumentTypeChange(e)
  }, process.env.PUBLIC_URL !== '/us' && /*#__PURE__*/React.createElement("option", {
    key: 'tax_computations',
    value: 'tax_computations'
  }, t('tax_computations')), /*#__PURE__*/React.createElement("option", {
    key: 'accounts',
    value: 'accounts'
  }, t('accounts')), /*#__PURE__*/React.createElement("option", {
    key: 'other',
    value: 'other'
  }, t('other'))))), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 1,
      offset: 1
    }
  }, renderSaveButton(window.MARKET_CONSTANTS.TECHNICAL_UPLOAD_SUBMIT_BUTTON_TYPE, {
    isImmutableUnderReview,
    loading,
    variant: 'primary',
    onClick: submit,
    disabled: isSignedOff
  }, t('submit')))))));
};
export default TechnicalUploadsForm;